const IsProd = true; //window.location.host === "riverrunes.gg";

export const CONTEST_API_ENDPOINT_TEST = "https://riverrunes-api.onetwo.gg";
export const CONTEST_API_ENDPOINT_PROD = "https://riverrunes-api.onetwo.gg";

export const API_ENDPOINT_TEST = "https://api.riverrunes.gg";
export const WEBSOCKET_ENDPOINT_TEST = "185.158.113.215:4000";

export const API_ENDPOINT_PROD = "https://riverrunes-api.onetwo.gg";
export const WEBSOCKET_ENDPOINT_PROD = "https://ws.riverrunes.gg";

export const CONTEST_API_ENDPOINT = IsProd
  ? CONTEST_API_ENDPOINT_PROD
  : CONTEST_API_ENDPOINT_TEST;
export const API_ENDPOINT = IsProd ? API_ENDPOINT_PROD : API_ENDPOINT_TEST;
export const WEBSOCKET_ENDPOINT = IsProd
  ? WEBSOCKET_ENDPOINT_PROD
  : WEBSOCKET_ENDPOINT_TEST;
